

import React, { useEffect, useState } from "react";
// import "./MobileSlider.css";
import "./LocalServicesSlider.css"
import { Select } from "antd";
import { Citys, cities, location1 } from "../../component/Location";
import { LocalServices, Mobiles, TechGadgets } from "../../component/env";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getExtraField } from "../../store/ProductFilterSlice";
const images = [
    "https://img.freepik.com/free-photo/full-shot-man-cleaning-indoors_23-2150454505.jpg?t=st=1740477040~exp=1740480640~hmac=84f72cab462272b9e10353a8c3beadc0e1935c2c748a44f18fac3c005a950f73&w=1380",
    "https://img.freepik.com/free-photo/people-taking-care-office-cleaning_23-2149374451.jpg?t=st=1740477646~exp=1740481246~hmac=1d6c45131a8db20c9d66ee0c5910e7cd425026592b15525cef5d42afda872ba0&w=1380",
    "https://img.freepik.com/free-photo/engineer-writing-condenser-values_482257-90848.jpg?t=st=1740479182~exp=1740482782~hmac=c6f7ca0fd6555dc32da8db0e919c53aaacd24530b78be61bad51217e3ca59ed5&w=1800",
    "https://img.freepik.com/free-photo/service-maintenance-worker-repairing_23-2149176719.jpg?t=st=1740479311~exp=1740482911~hmac=a89a969c02a860f0fbc13da26d2abb16ae5e10204cf71058f99180f862e5bf7c&w=1380",
    "https://img.freepik.com/free-photo/two-workers-uniform-workers-with-tools-working-day_1157-46525.jpg?t=st=1740479503~exp=1740483103~hmac=6c515fe2be30439b4cef9a1c2cf04875a7a21cc497729732a56d6eb3fd77965f&w=1380",
    "https://img.freepik.com/free-photo/courier-using-tablet-car_23-2147767612.jpg?t=st=1740479685~exp=1740483285~hmac=b6c9f754dc0800867bb2520c6357e3ade3945aada68c269a555c99b77012e9cf&w=1380"
];

const LocalServicesSlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible1, setVisible1] = useState(false);
    const handleDropdownVisibleChange = (open) => {
        setVisible1(open);
    };
    const [visible2, setVisible2] = useState(false);
    const handleDropdownVisibleChange2 = (open) => {
        setVisible2(open);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const mobilestyle = {
        height: "200px",
        width: "100%",
    };
    const desktopstyle = {
        height: "440px",
        width: "90%",
        marginLeft: "1.5cm",
        marginRight: "2.5cm",
        borderRadius: "20px",
    };
    const mobstyle = {
        display: "flex",
        flexDirection: "column",
    };
    const deskstyle = {
        display: "flex",
        flexDirection: "row",
    };

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [loading, setLoading] = useState(false); // Setting up a state variable 'loading' and its setter function 'setLoading' with initial value 'false'
    const disptach = useDispatch();
    const dispatch = useDispatch();
    // Accessing the Redux dispatch function
    const [errorMessage, setErrorMessage] = useState(null);
    const [extraFieldCopy, setExtraFieldCopy] = useState({});
    const [city, setCity] = useState();
    const [category, setCategory] = useState();
    const [cityError, setCityError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [searchSending, setsearchSending] = useState({
        subCategoryType: null,
        subCategoryValue: null,
        City: null,
        searchValue: null,
        category: "TechGadgets",
        minPrice: null,
        maxPrice: null,
    }); // State for search form data

    //   const disptach = useDispatch(); // Initializing useDispatch hook

    // Event handler for input field changes
    const handleChange = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setExtraFieldCopy({ [name]: value });
        // setsearchSending({ ...searchSending, [name]: value });
        // disptach(getExtraField(searchSending)); // Dispatching getExtraField action
    };

    useEffect(() => {
        // Update searchSending state with the selected filter value
        if (selectedFilter !== null) {
            setsearchSending((prevState) => ({
                ...prevState,
                category: selectedFilter,
            }));
        }
    }, [selectedFilter]);
    return (
        <>
            <div
                className="techslide tech-slide-awi-26 mt-4 mb-3"
            // style={isMobile ? mobstyle : deskstyle}
            >
                <div className="search-form-awi-26">
                    <h1
                        style={{
                            fontSize: "20px",
                            fontFamily: "times",
                            borderBottom: "1px double white",
                            borderTop: "1px double white",
                            fontWeight: "bold",
                            color: "brown",
                        }}
                    >
                        SEARCH FOR LOCAL SERVICES
                    </h1>
                    <div className="form-group2 mt-3">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select City :
                        </h6>
                        <Select
                            open={visible1}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{
                                width: "15rem",
                                padding: "5px 0px",
                            }}
                            placeholder="Select City"
                            onChange={(value) => setCity(value)}
                            options={Citys.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                            showSearch={true}
                            filterOption={(inputValue, option) =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                            }
                        />
                        {cityError && <p className="error-message">{cityError}</p>}
                    </div>
                    <div className="form-group2">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select Category :
                        </h6>
                        <Select
                            open={visible2}
                            onDropdownVisibleChange={handleDropdownVisibleChange2}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ width: "15rem" }}
                            placeholder="select category"
                            value={category || null}
                            onChange={(value) => setCategory(value)}
                            options={LocalServices.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                        />
                        {categoryError && <p className="error-message">{categoryError}</p>}
                    </div>
                    <Link
                        to={`/ads-listing/`}
                        onClick={(e) => {
                            if (!city || !category) {
                                e.preventDefault(); // Prevent the default navigation behavior
                                console.log("Please select both City and Category.");
                                setErrorMessage("Please select both City and Category."); // Set an error message
                            } else {
                                setErrorMessage(null); // Clear any previous error message

                                for (const key in searchSending) {
                                    if (
                                        searchSending[key]?.trim() === "" ||
                                        searchSending[key] === null
                                    ) {
                                        delete searchSending[key];
                                    }
                                }
                                searchSending["extraField"] = { ...extraFieldCopy };
                                searchSending["subCategoryValue"] = category;
                                searchSending["City"] = city;
                                disptach(getExtraField(searchSending));
                            }
                        }}
                    >
                        <button className="buttonno12">Search</button>
                    </Link>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>

                <div className="carousel-innertech24-awi-26">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-item${index === activeIndex ? " active" : ""
                                }`}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={isMobile ? mobilestyle : desktopstyle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default LocalServicesSlider;
